var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g5, _g6, _g7, _g8, _g9, _path9, _path10, _path11, _path12, _path13, _g10, _g11, _g12, _g13, _g14, _path14, _path15, _path16, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path17, _path18, _path19, _path20, _path21, _path22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _path23, _path24, _path25, _path26, _g36, _g37, _path27, _g38, _g39, _path28, _g40, _g41, _g42, _g43, _g44, _path29, _path30, _path31, _path32, _path33, _g45, _path34, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g57, _path42, _g58, _path43, _path44, _path45, _path46, _path47, _g59, _path48, _g60, _g61, _g62, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g63;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideDecsPhase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1046.59 1640.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .slide-decks-disable-rect{\n        fill: #edeef0;\n      }\n      .slide-decks-disable-rect:hover {\n        pointer-events: none;\n        fill: #edeef0;  \n      }\n\n      .cls-1-slide-decs-p2, .cls-2-slide-decs-p2, .cls-3-slide-decs-p2, .cls-4-slide-decs-p2, .cls-5-slide-decs-p2, .cls-6-slide-decs-p2, .cls-7-slide-decs-p2 {\n        stroke-width: 0px;\n      }\n\n      .cls-1-slide-decs-p2, .cls-8-slide-decs-p2 {\n        fill: rgba(255, 255, 255, 0);\n      }\n\n      .cls-9-slide-decs-p2 {\n        fill: url(#linear-gradient-2-slide-decs-P2);\n      }\n\n      .cls-9-slide-decs-p2, .cls-10-slide-decs-p2, .cls-11-slide-decs-p2, .cls-12-slide-decs-p2, .cls-13-slide-decs-p2, .cls-14-slide-decs-p2, .cls-15-slide-decs-p2, .cls-16-slide-decs-p2 {\n        stroke: #1071e5;\n      }\n\n      .cls-10-slide-decs-p2, .cls-3-slide-decs-p2 {\n        fill: #fff;\n      }\n\n      .cls-11-slide-decs-p2, .cls-12-slide-decs-p2, .cls-5-slide-decs-p2 {\n        fill: #1071e5;\n      }\n\n      .cls-2-slide-decs-p2, .cls-15-slide-decs-p2 {\n        fill: none;\n      }\n\n      .cls-8-slide-decs-p2 {\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .cls-12-slide-decs-p2 {\n        stroke-width: .05px;\n      }\n\n      .cls-13-slide-decs-p2 {\n        fill: url(#linear-gradient-3-slide-decs-P2);\n      }\n      .cls-13-slide-decs-p2:hover{\n        fill: url(#linear-gradient-3-slide-decs-P2);\n        pointer-events: none;\n      }\n\n      .cls-14-slide-decs-p2 {\n        fill: url(#linear-gradient-4-slide-decs-P2);\n      }\n\n      .cls-14-slide-decs-p2:hover {\n        fill: url(#linear-gradient-4-slide-decs-P2);\n        pointer-events: none;\n      }\n\n      .cls-4-slide-decs-p2 {\n        fill: #3a414a;\n      }\n\n      .cls-6-slide-decs-p2 {\n        fill: #e81313;\n      }\n\n      .cls-7-slide-decs-p2 {\n        fill: #008a0e;\n      }\n\n      .cls-16-slide-decs-p2 {\n        fill: url(#linear-gradient-1-slide-decs-P2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1-slide-decs-P2",
    x1: 165.69,
    y1: 1827.98,
    x2: 165.69,
    y2: 1659.32,
    gradientTransform: "translate(86.01 2223.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-slide-decs-P2",
    x1: 786.82,
    y1: 1810.47,
    x2: 786.82,
    y2: 1668.07,
    gradientTransform: "translate(86.01 2223.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-slide-decs-P2",
    x1: 165.7,
    y1: 1583.6,
    x2: 165.7,
    y2: 1366.11,
    gradientTransform: "translate(86.01 2223.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4-slide-decs-P2",
    x1: 162.87,
    y1: 910.51,
    x2: 162.87,
    y2: 768.11,
    gradientTransform: "translate(86.01 2223.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p2",
    d: "M82.73,75.73c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v89.33c0,3.31-2.69,6-6,6H88.72c-3.31,0-6-2.69-6-6v-89.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-4-slide-decs-p2",
    d: "M156.59,117.89c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM150,117.14c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM150,124.95c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-4-slide-decs-p2",
    d: "M169.76,115.72c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-4-slide-decs-p2",
    d: "M171.73,111.1v-2.04h2.17v2.04h-2.17ZM171.73,126.79v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-4-slide-decs-p2",
    d: "M182.26,113.61c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM185.79,119.11c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "cls-4-slide-decs-p2",
    d: "M195.9,110.9c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-2",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M197.46,111.1v-2.04h2.17v2.04h-2.17ZM197.46,126.79v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-4-slide-decs-p2",
    d: "M209.14,113.61c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-4-slide-decs-p2",
    d: "M226.8,113.88c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM221.16,125.29c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-4-slide-decs-p2",
    d: "M239.16,123.59c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "cls-4-slide-decs-p2",
    d: "M249.14,115.31c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-2",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M262.31,113.61c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM265.84,119.11c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-4-slide-decs-p2",
    d: "M285.06,117.08c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "cls-4-slide-decs-p2",
    d: "M295.92,113.61c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM295.38,125.43c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-3",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M308.48,113.61c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM312.01,119.11c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "cls-4-slide-decs-p2",
    d: "M324.85,124.34c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM318.53,123.19c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-4-slide-decs-p2",
    d: "M338.56,126.79l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-4",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M347.87,113.61c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM351.4,119.11c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-2",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M362.4,115.72c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-15-slide-decs-p2",
    d: "M253.85,172.06v46.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M254.35,172.08h-1v-.52h1v.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-slide-decs-p2",
    d: "M253.85,232.88l-4.63-14.28h9.27l-4.64,14.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M65.84,120.9H6.59l-.88.07-.83.2-.8.33-.75.45-.65.56-.56.67-.45.73-.34.8-.2.84-.07.88v616.3l.06.88.2.84.33.8.44.74.56.65.65.56.74.44.8.33.83.2.88.07h8.62v1H6.53l-1-.08-1-.23-.94-.4-.87-.53-.77-.66-.67-.78-.54-.87-.4-.95-.24-1-.07-1V126.4l.06-1,.24-1,.4-.93.53-.88.66-.77.76-.66.87-.54.95-.4,1-.23,1-.07h59.27l.08.98ZM82.87,748.24v1h-18.78v-1h18.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M83.37,748.74l.05.5h-.56v-1h.56l-.05.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M83.39,748.74l.06.53h-.62v-1.05h.62l-.06.52ZM82.89,748.27v.95h.5l-.05-.48.05-.47h-.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M80.61,120.4l-14.27,4.63v-9.27l14.27,4.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M82.22,120.4l-16.38,5.32v-10.65l16.38,5.33ZM66.84,124.34l12.15-3.94-12.15-3.95v7.89Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-7-slide-decs-p2",
    d: "M24.53,746.64v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-7-slide-decs-p2",
    d: "M33.56,753.63v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-7-slide-decs-p2",
    d: "M60.38,740.8c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16-slide-decs-p2",
    d: "M246.32,398.27c3.39-1.67,7.37-1.67,10.76,0l160.36,79.03c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.35,79.03c-3.39,1.67-7.38,1.67-10.77,0l-160.36-79.03c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.03Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-3-slide-decs-p2",
    d: "M200.42,452.81c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-3-slide-decs-p2",
    d: "M205.79,465.64v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-3-slide-decs-p2",
    d: "M211.15,449.96v-2.04h2.17v2.04h-2.17ZM211.15,465.64v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "cls-3-slide-decs-p2",
    d: "M220.66,452.47c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM221.27,454.1c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-3-slide-decs-p2",
    d: "M235.26,452.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM238.79,457.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "cls-3-slide-decs-p2",
    d: "M251.21,455.93c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "cls-3-slide-decs-p2",
    d: "M275.32,454.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M288.15,452.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM291.68,457.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-3",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M301.73,452.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM305.26,457.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "cls-3-slide-decs-p2",
    d: "M312.53,462.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-4",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M183.04,493.54c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM186.57,499.04c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "cls-3-slide-decs-p2",
    d: "M199.4,506.71l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "cls-3-slide-decs-p2",
    d: "M209.86,493.54c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM209.32,505.35c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-5",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M222.42,493.54c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM225.95,499.04c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-3-slide-decs-p2",
    d: "M235.73,495.23c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M245.44,503.52c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-3-slide-decs-p2",
    d: "M257.8,504.27c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM251.48,503.11c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-3",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M265.81,503.52c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "cls-3-slide-decs-p2",
    d: "M270.22,491.02v-2.04h2.17v2.04h-2.17ZM270.22,506.71v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-3-slide-decs-p2",
    d: "M280.75,493.54c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM280.68,505.35c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-3-slide-decs-p2",
    d: "M295.48,493.54c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "cls-3-slide-decs-p2",
    d: "M310.29,497c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-3-slide-decs-p2",
    d: "M320.34,489.67c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM318.57,506.71v-2.38h2.31v2.38h-2.31"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M252.19,624.86h-1v-14.5h1v14.5ZM252.19,581.02h-1v-17.14h1v17.14Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M251.69,563.38l.5-.02v.54h-1v-.54l.5.02Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M251.69,563.35l.54-.02v.6h-1.05v-.6l.51.02ZM251.23,563.87h.95v-.5l-.5.04-.46-.02v.48Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M251.69,639.63l-4.62-14.27h9.27l-4.65,14.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M251.69,641.24l-5.3-16.38h10.63l-5.33,16.38ZM247.75,625.86l3.95,12.15,3.96-12.14h-7.91Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-6-slide-decs-p2",
    d: "M246.31,600.57l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "cls-6-slide-decs-p2",
    d: "M260.51,583.53c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM260.51,598.94c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p2",
    d: "M80.59,241c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6H86.59c-3.31,0-6-2.69-6-6h0v-86.66Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "cls-4-slide-decs-p2",
    d: "M164.27,277.86c-.31-2.96-7.59-3.33-7.65.12.86,4.63,9.75.86,10.06,7.35.19,4.81-7.47,5.37-10.8,3.4-1.05-.62-1.73-1.6-2.04-2.84l2.04-.43c.31,3.46,8.7,3.89,8.7-.06,0-4.81-9.57-.86-10-7.28-.31-5.06,8.95-5.19,11.05-2.1.31.43.49.99.68,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "cls-4-slide-decs-p2",
    d: "M169.15,289.52v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-3",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M174.02,275.26v-1.85h1.98v1.85h-1.98ZM174.02,289.52v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "cls-4-slide-decs-p2",
    d: "M182.67,277.55c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM183.22,279.03c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-5",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M195.94,277.55c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM199.15,282.55c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M213.53,277.55c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM214.09,279.03c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-6",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M226.8,277.55c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM230.01,282.55c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "cls-4-slide-decs-p2",
    d: "M238.9,279.09c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-2",
    "data-name": "Y",
    className: "cls-4-slide-decs-p2",
    d: "M252.91,289.52l-3.95-5.37-1.42,1.17v4.2h-1.98v-16.11h1.98v10.06l5.12-5.68h2.28l-4.75,5.06,5.06,6.67h-2.35"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M266.62,277.55c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM267.17,279.03c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-7",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M279.89,277.55c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM283.1,282.55c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M287.54,289.52v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-4",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M292.42,275.26v-1.85h1.98v1.85h-1.98ZM292.42,289.52v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "cls-4-slide-decs-p2",
    d: "M302.48,289.52h-2.35l-4.26-11.73h2.1l3.33,10.19,3.46-10.19h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-8",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M313.1,277.55c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM316.31,282.55c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-3",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M326.31,279.46c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-9",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M332.79,277.55c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM336,282.55c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M344.21,277.55c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM344.77,279.03c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15-slide-decs-p2",
    d: "M251.69,334.66v45.48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M252.19,334.67h-1v-.5h1v.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-slide-decs-p2",
    d: "M251.69,394.9l-4.62-14.27h9.27l-4.65,14.27Z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p2",
    d: "M703.86,89.13c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v108.8c0,3.31-2.69,6-6,6h-330.23c-3.31,0-6-2.69-6-6v-108.8Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M-2",
    "data-name": "M",
    className: "cls-4-slide-decs-p2",
    d: "M740.4,120.08c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM733.82,119.33c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM733.82,127.14c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-4",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M753.58,117.9c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-5",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M755.55,113.29v-2.04h2.17v2.04h-2.17ZM755.55,128.97v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-10",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M766.07,115.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM769.6,121.3c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q-2",
    "data-name": "Q",
    className: "cls-4-slide-decs-p2",
    d: "M779.72,113.08c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-6",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M781.28,113.29v-2.04h2.17v2.04h-2.17ZM781.28,128.97v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-2",
    "data-name": "R",
    className: "cls-4-slide-decs-p2",
    d: "M792.96,115.8c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-2",
    "data-name": "S",
    className: "cls-4-slide-decs-p2",
    d: "M810.61,116.07c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM804.98,127.48c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "cls-4-slide-decs-p2",
    d: "M821.21,128.97v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-3",
    "data-name": "M",
    className: "cls-4-slide-decs-p2",
    d: "M836.62,120.08c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM830.03,119.33c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM830.03,127.14c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "cls-4-slide-decs-p2",
    d: "M857.8,122.66c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "cls-4-slide-decs-p2",
    d: "M864.25,126.39c.07,2.31,0,4.41-.95,5.7h-1.49c.61-.88,1.15-1.77,1.15-3.12h-1.09v-2.58h2.38"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X-2",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M882.79,126.53c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM876.48,125.37c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-3",
    "data-name": "S",
    className: "cls-4-slide-decs-p2",
    d: "M898.82,116.07c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM893.18,127.48c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-11",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M907.17,115.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM910.7,121.3c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-3",
    "data-name": "R",
    className: "cls-4-slide-decs-p2",
    d: "M921.9,115.8c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M934.06,117.5c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "cls-4-slide-decs-p2",
    d: "M951.92,116.07l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "cls-4-slide-decs-p2",
    d: "M965.56,115.8c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM965.5,127.61c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-5",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M980.09,117.9c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-2",
    "data-name": "T",
    className: "cls-4-slide-decs-p2",
    d: "M991.23,125.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-2",
    "data-name": "U",
    className: "cls-4-slide-decs-p2",
    d: "M1001.21,117.5c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-12",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M1014.38,115.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1017.92,121.3c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "cls-4-slide-decs-p2",
    d: "M776.05,156.86c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM775.51,168.68c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-6",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M789.56,158.97c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-3",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M799.48,167.59c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM793.16,166.44c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-4",
    "data-name": "R",
    className: "cls-4-slide-decs-p2",
    d: "M811.43,156.86c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-5",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M822.84,156.86c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM823.45,158.49c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "cls-4-slide-decs-p2",
    d: "M830.64,170.31l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "cls-4-slide-decs-p2",
    d: "M851.69,158.56c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-13",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M864.53,156.86c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM868.06,162.36c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-6",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M877.09,156.86c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM877.7,158.49c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-7",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M886.53,154.35v-2.04h2.17v2.04h-2.17ZM886.53,170.04v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-3",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M896.78,158.56c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-4",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M912.06,167.59c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM905.74,166.44c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M917.69,170.04v-17.72h2.17v17.72h-2.17"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-3",
    "data-name": "T",
    className: "cls-4-slide-decs-p2",
    d: "M932.22,166.85c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-14",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M941.8,156.86c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM945.33,162.36c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-5",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M958.16,167.59c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM951.85,166.44c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-2",
    "data-name": "aF",
    className: "cls-4-slide-decs-p2",
    d: "M976.43,158.56c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15-slide-decs-p2",
    d: "M875,204.94v25.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M875.5,204.95h-1v-.5h1v.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-slide-decs-p2",
    d: "M875,245.22l-4.65-14.27h9.27l-4.62,14.27Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M872.19,622.1h-1v-15.2h1v15.2ZM873.33,577.56h-1v-23.5h1v23.5ZM873.33,554.06h-1v-3.5h1v3.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M871.69,636.86l-4.6-14.26h9.27l-4.67,14.26Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M871.69,638.48l-5.3-16.4h10.63l-5.33,16.4ZM867.75,623.08l3.95,12.16,3.96-12.15h-7.91Z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "d-2",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "cls-7-slide-decs-p2",
    d: "M857.7,590.12v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-2",
    "data-name": "aa",
    className: "cls-7-slide-decs-p2",
    d: "M866.73,597.12v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "cls-7-slide-decs-p2",
    d: "M893.55,584.28c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9-slide-decs-p2",
    d: "M867.3,415.43c3.55-1.48,7.53-1.48,11.08,0l160.05,66.6c1.27.54,1.86,2.01,1.32,3.28-.25.59-.73,1.07-1.32,1.32l-160.05,66.6c-3.55,1.48-7.53,1.48-11.08,0l-160.05-66.6c-1.27-.54-1.86-2.01-1.32-3.28.25-.59.73-1.07,1.32-1.32l160.05-66.6Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "f-2",
    "data-name": "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "cls-3-slide-decs-p2",
    d: "M822.05,455.73c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "cls-3-slide-decs-p2",
    d: "M827.41,468.56v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-3",
    "data-name": "ae",
    className: "cls-3-slide-decs-p2",
    d: "M832.78,452.87v-2.04h2.17v2.04h-2.17ZM832.78,468.56v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "cls-3-slide-decs-p2",
    d: "M842.28,455.39c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM842.89,457.02c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-6",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M856.88,455.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM860.41,460.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "cls-3-slide-decs-p2",
    d: "M872.84,458.85c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    "data-name": "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "cls-3-slide-decs-p2",
    d: "M896.94,457.08c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-7",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M909.78,455.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM913.31,460.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-8",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M923.36,455.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM926.89,460.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-4",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M934.15,465.37c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "h-2",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-9",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M804.67,496.45c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM808.2,501.95c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-2",
    "data-name": "ak",
    className: "cls-3-slide-decs-p2",
    d: "M821.03,509.63l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-2",
    "data-name": "al",
    className: "cls-3-slide-decs-p2",
    d: "M831.49,496.45c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM830.94,508.27c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-10",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M844.05,496.45c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM847.58,501.95c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-2",
    "data-name": "am",
    className: "cls-3-slide-decs-p2",
    d: "M857.36,498.15c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-5",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M867.07,506.43c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-3-slide-decs-p2",
    d: "M879.42,507.18c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM873.11,506.03c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-6",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M887.44,506.43c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-4",
    "data-name": "ae",
    className: "cls-3-slide-decs-p2",
    d: "M891.85,493.94v-2.04h2.17v2.04h-2.17ZM891.85,509.63v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "cls-3-slide-decs-p2",
    d: "M902.38,496.45c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM902.31,508.27c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "cls-3-slide-decs-p2",
    d: "M917.11,496.45c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "cls-3-slide-decs-p2",
    d: "M931.91,499.92c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "cls-3-slide-decs-p2",
    d: "M941.96,492.58c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM940.2,509.63v-2.38h2.31v2.38h-2.31"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p2",
    d: "M701.69,253.34c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-86.66Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "j-2",
    "data-name": "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "cls-4-slide-decs-p2",
    d: "M785.4,290.2c-.31-2.96-7.59-3.33-7.65.12.86,4.63,9.75.86,10.06,7.35.19,4.81-7.47,5.37-10.8,3.4-1.05-.62-1.73-1.6-2.04-2.84l2.04-.43c.31,3.46,8.7,3.89,8.7-.06,0-4.81-9.57-.86-10-7.28-.31-5.06,8.95-5.19,11.05-2.1.31.43.49.99.68,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M790.27,301.86v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-8",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M795.15,287.6v-1.85h1.98v1.85h-1.98ZM795.15,301.86v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-7",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M803.79,289.89c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM804.35,291.37c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-15",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M817.06,289.89c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM820.27,294.89c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "k-2",
    "data-name": "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-8",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M834.66,289.89c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM835.21,291.37c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-16",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M847.93,289.89c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM851.14,294.89c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-4",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M860.03,291.43c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-3",
    "data-name": "Y",
    className: "cls-4-slide-decs-p2",
    d: "M874.04,301.86l-3.95-5.37-1.42,1.17v4.2h-1.98v-16.11h1.98v10.06l5.12-5.68h2.28l-4.75,5.06,5.06,6.67h-2.35"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "l-2",
    "data-name": "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-9",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M887.74,289.89c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM888.3,291.37c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-17",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M901.02,289.89c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM904.23,294.89c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M908.67,301.86v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-9",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M913.55,287.6v-1.85h1.98v1.85h-1.98ZM913.55,301.86v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "cls-4-slide-decs-p2",
    d: "M923.61,301.86h-2.35l-4.26-11.73h2.1l3.33,10.19,3.46-10.19h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-18",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M934.23,289.89c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM937.44,294.89c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-7",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M947.44,291.8c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-19",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M953.92,289.89c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM957.13,294.89c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-10",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M965.34,289.89c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM965.89,291.37c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p2",
    d: "M700.59,644.48c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v92c0,3.31-2.69,6-6,6h-330.24c-3.31,0-6-2.69-6-6v-92Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "cls-4-slide-decs-p2",
    d: "M812.29,683.67c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "cls-4-slide-decs-p2",
    d: "M829.68,692.77c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM826.62,688.09c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-2",
    "data-name": "aH",
    className: "cls-4-slide-decs-p2",
    d: "M843.26,692.77c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM840.2,688.09c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "cls-4-slide-decs-p2",
    d: "M852.69,679.19c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM856.23,687.41c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "cls-4-slide-decs-p2",
    d: "M875.1,685.37c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "cls-4-slide-decs-p2",
    d: "M891.26,693.72c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM888,693.93c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "cls-4-slide-decs-p2",
    d: "M905.11,686.66c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-3",
    "data-name": "aH",
    className: "cls-4-slide-decs-p2",
    d: "M921.95,692.77c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM918.9,688.09c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "cls-4-slide-decs-p2",
    d: "M938.45,687.41c2.31.27,3.8,1.43,4.01,3.94.48,6.18-10.05,6.38-11.68,1.9-.27-.61-.41-1.15-.48-1.77l3.46-.34c.07,1.63,1.09,2.38,2.72,2.44,1.56,0,2.65-.81,2.58-2.44-.07-2.1-2.1-2.44-4.41-2.31v-2.72c2.17.14,4.01-.2,4.01-2.24,0-1.36-.88-2.24-2.31-2.24s-2.24.88-2.38,2.17l-3.4-.2c.41-2.99,2.51-4.62,5.84-4.62s5.64,1.36,5.64,4.48c0,2.38-1.49,3.53-3.6,3.94"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15-slide-decs-p2",
    d: "M872.83,347v50.44"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M873.33,347h-1v-.5h1v.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-slide-decs-p2",
    d: "M872.83,412.2l-4.64-14.26h9.27l-4.63,14.26Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-slide-decs-p2",
    d: "M80.59,13.66c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v48c0,3.31-2.69,6-6,6H86.59c-3.31,0-6-2.69-6-6h0V13.66Z"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG-2",
    "data-name": "aG",
    className: "cls-4-slide-decs-p2",
    d: "M153.1,47.53c-.06-2.65-5.8-2.84-5.99-.19,1.11,4.07,9.32.62,9.51,7.04.19,5.86-10.19,5.74-12.59,2.22-.37-.49-.62-1.17-.74-1.85l3.09-.49c.19,2.84,6.91,3.46,7.16.31-1.05-4.26-9.26-.62-9.51-7.04-.25-5.37,9.44-5.43,11.6-2.16.31.49.49,1.11.62,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "cls-4-slide-decs-p2",
    d: "M158.96,43.46c5.74.06,12.72-.99,12.59,4.88-.06,4.63-4.26,5.43-9.38,5.06v5.37h-3.21v-15.31ZM162.17,50.93c2.9,0,6.17.43,6.17-2.53s-3.33-2.41-6.17-2.41v4.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "cls-4-slide-decs-p2",
    d: "M173.78,58.77v-15.31h12.04v2.47h-8.83v3.89h8.15v2.47h-8.15v4.01h9.26v2.47h-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-4-slide-decs-p2",
    d: "M199.4,58.77l-1.36-3.89h-5.8l-1.36,3.89h-3.21l5.56-15.31h3.77l5.56,15.31h-3.15ZM197.36,52.47l-2.22-6.67c-.62,2.35-1.48,4.44-2.22,6.67h4.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-4-slide-decs-p2",
    d: "M215.14,58.77l-5.43-7.04-1.91,1.48v5.56h-3.21v-15.31h3.21v6.98l6.91-6.98h3.7l-6.54,6.48,7.1,8.83h-3.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-2",
    "data-name": "aN",
    className: "cls-4-slide-decs-p2",
    d: "M220.57,58.77v-15.31h12.04v2.47h-8.83v3.89h8.15v2.47h-8.15v4.01h9.26v2.47h-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-4-slide-decs-p2",
    d: "M248.72,48.03c0,2.47-1.42,3.77-3.33,4.32l4.14,6.42h-3.64l-3.52-5.8h-3.77v5.8h-3.21v-15.31c5.74.25,13.4-1.42,13.33,4.57ZM238.59,50.5c2.96-.12,6.91.74,6.91-2.35s-4.07-1.98-6.91-2.16v4.51"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-4-slide-decs-p2",
    d: "M260.2,51.05c0,3.27,1.3,5.37,4.51,5.43,2.28.06,3.33-1.36,4.01-2.9l2.78,1.05c-1.05,2.59-3.15,4.38-6.79,4.38-5.06,0-7.41-2.84-7.72-7.96-.43-6.79,6.73-9.63,12.1-6.6,1.11.62,1.79,1.79,2.22,3.09l-2.84.74c-.49-1.54-1.85-2.53-3.83-2.53-3.21,0-4.38,2.1-4.44,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-2",
    "data-name": "aQ",
    className: "cls-4-slide-decs-p2",
    d: "M286.86,48.03c0,2.47-1.42,3.77-3.33,4.32l4.14,6.42h-3.64l-3.52-5.8h-3.77v5.8h-3.21v-15.31c5.74.25,13.4-1.42,13.33,4.57ZM276.74,50.5c2.96-.12,6.91.74,6.91-2.35s-4.07-1.98-6.91-2.16v4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-3",
    "data-name": "aN",
    className: "cls-4-slide-decs-p2",
    d: "M289.52,58.77v-15.31h12.04v2.47h-8.83v3.89h8.15v2.47h-8.15v4.01h9.26v2.47h-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-4-slide-decs-p2",
    d: "M315.14,58.77l-1.36-3.89h-5.8l-1.36,3.89h-3.21l5.56-15.31h3.77l5.56,15.31h-3.15ZM313.1,52.47l-2.22-6.67c-.62,2.35-1.48,4.44-2.22,6.67h4.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-4-slide-decs-p2",
    d: "M325.57,45.93v12.84h-3.21v-12.84h-4.94v-2.47h13.09v2.47h-4.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-4",
    "data-name": "aN",
    className: "cls-4-slide-decs-p2",
    d: "M332.17,58.77v-15.31h12.04v2.47h-8.83v3.89h8.15v2.47h-8.15v4.01h9.26v2.47h-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-4-slide-decs-p2",
    d: "M346.99,43.46c7.41-.43,13.77.31,13.64,7.53-.06,4.94-2.72,7.78-7.47,7.78h-6.17v-15.31ZM350.2,56.3c4.57.43,7.22-1.11,7.22-5.31s-2.78-5.43-7.22-5.06v10.37"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p2",
    d: "M701.69,6c0-3.31,2.69-6,6-6h328c3.31,0,6,2.69,6,6v68c0,3.31-2.69,6-6,6h-328c-3.31,0-6-2.69-6-6V6Z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-4-slide-decs-p2",
    d: "M787.85,73.92v-15.31h3.21v12.84h8.21v2.47h-11.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-4-slide-decs-p2",
    d: "M801.37,73.92v-15.31h3.21v15.31h-3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-2",
    "data-name": "aU",
    className: "cls-4-slide-decs-p2",
    d: "M807.54,73.92v-15.31h3.21v12.84h8.21v2.47h-11.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-3",
    "data-name": "aU",
    className: "cls-4-slide-decs-p2",
    d: "M821.06,73.92v-15.31h3.21v12.84h8.21v2.47h-11.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-4-slide-decs-p2",
    d: "M840.07,67.62v6.3h-3.21v-6.3l-5.43-9.01h3.33l3.7,6.48,3.7-6.48h3.33"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "x-2",
    "data-name": "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "cls-4-slide-decs-p2",
    d: "M855.75,66.2c0,3.27,1.3,5.37,4.51,5.43,2.28.06,3.33-1.36,4.01-2.9l2.78,1.05c-1.05,2.59-3.15,4.38-6.79,4.38-5.06,0-7.41-2.84-7.72-7.96-.43-6.79,6.73-9.63,12.1-6.6,1.11.62,1.79,1.79,2.22,3.09l-2.84.74c-.49-1.54-1.85-2.53-3.83-2.53-3.21,0-4.38,2.1-4.44,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-3",
    "data-name": "aQ",
    className: "cls-4-slide-decs-p2",
    d: "M882.42,63.18c0,2.47-1.42,3.77-3.33,4.32l4.14,6.42h-3.64l-3.52-5.8h-3.77v5.8h-3.21v-15.31c5.74.25,13.4-1.42,13.33,4.57ZM872.29,65.65c2.96-.12,6.91.74,6.91-2.35s-4.07-1.98-6.91-2.16v4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-5",
    "data-name": "aN",
    className: "cls-4-slide-decs-p2",
    d: "M885.07,73.92v-15.31h12.04v2.47h-8.83v3.89h8.15v2.47h-8.15v4.01h9.26v2.47h-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-3",
    "data-name": "aO",
    className: "cls-4-slide-decs-p2",
    d: "M910.69,73.92l-1.36-3.89h-5.8l-1.36,3.89h-3.21l5.56-15.31h3.77l5.56,15.31h-3.15ZM908.65,67.62l-2.22-6.67c-.62,2.35-1.48,4.44-2.22,6.67h4.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "cls-4-slide-decs-p2",
    d: "M921.12,61.08v12.84h-3.21v-12.84h-4.94v-2.47h13.09v2.47h-4.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-6",
    "data-name": "aN",
    className: "cls-4-slide-decs-p2",
    d: "M927.73,73.92v-15.31h12.04v2.47h-8.83v3.89h8.15v2.47h-8.15v4.01h9.26v2.47h-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-2",
    "data-name": "aT",
    className: "cls-4-slide-decs-p2",
    d: "M942.54,58.61c7.41-.43,13.77.31,13.64,7.53-.06,4.94-2.72,7.78-7.47,7.78h-6.17v-15.31ZM945.75,71.45c4.57.43,7.22-1.11,7.22-5.31s-2.78-5.43-7.22-5.06v10.37"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-slide-decs-p2",
    d: "M246.64,643.22c3.09-1.97,7.04-1.97,10.13,0l161,102.3c1.78,1.11,2.32,3.46,1.2,5.24-.3.49-.72.9-1.2,1.2l-161,102.3c-3.09,1.97-7.04,1.97-10.13,0l-161-102.3c-1.78-1.11-2.32-3.46-1.2-5.24.3-.49.72-.9,1.2-1.2l161-102.3Z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-3-slide-decs-p2",
    d: "M217.13,703.28c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-3-slide-decs-p2",
    d: "M227.51,703.95c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "cls-3-slide-decs-p2",
    d: "M243.47,712.99c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM237.16,711.83c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-3",
    "data-name": "ap",
    className: "cls-3-slide-decs-p2",
    d: "M255.42,702.26c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-3-slide-decs-p2",
    d: "M273.08,702.53c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM267.44,713.94c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-11",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M281.43,702.26c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM284.96,707.76c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-5",
    "data-name": "ah",
    className: "cls-3-slide-decs-p2",
    d: "M297.38,705.72c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-3-slide-decs-p2",
    d: "M134.76,745.43c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-12",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M141.89,743.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM145.42,748.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-3-slide-decs-p2",
    d: "M158.53,754.39c-.75,1.49-1.97,2.38-4.07,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.01,1.15-6.72,4.75-6.79,2.17-.07,3.26.95,4.07,2.24,0-.75-.07-1.63.14-2.17h2.04l-.07,18.2h-2.17l.07-7.2ZM155,755.07c2.78,0,3.46-2.24,3.46-5.16s-.54-4.96-3.4-4.96-3.12,2.38-3.12,5.09.34,5.02,3.06,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-3-slide-decs-p2",
    d: "M167.97,756.77c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-5",
    "data-name": "ae",
    className: "cls-3-slide-decs-p2",
    d: "M177.47,740.81v-2.04h2.17v2.04h-2.17ZM177.47,756.5v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-2",
    "data-name": "ba",
    className: "cls-3-slide-decs-p2",
    d: "M188.95,745.43c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-13",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M196.08,743.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM199.61,748.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-3",
    "data-name": "af",
    className: "cls-3-slide-decs-p2",
    d: "M208.64,743.32c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM209.25,744.95c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "cls-3-slide-decs-p2",
    d: "M232.81,754.05c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM226.5,752.9c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-3-slide-decs-p2",
    d: "M243.68,740.61c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd-2",
    "data-name": "bd",
    className: "cls-3-slide-decs-p2",
    d: "M249.99,740.61c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-14",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M256.71,743.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM260.24,748.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-3",
    "data-name": "am",
    className: "cls-3-slide-decs-p2",
    d: "M270.02,745.02c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-7",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M279.73,753.31c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-6",
    "data-name": "ah",
    className: "cls-3-slide-decs-p2",
    d: "M298.47,746.79c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-3",
    "data-name": "al",
    className: "cls-3-slide-decs-p2",
    d: "M309.34,743.32c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM308.79,755.14c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-15",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M321.9,743.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM325.43,748.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "cls-3-slide-decs-p2",
    d: "M338.26,754.05c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM331.95,752.9c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-3-slide-decs-p2",
    d: "M351.98,756.5l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-16",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M361.28,743.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM364.81,748.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-3",
    "data-name": "ba",
    className: "cls-3-slide-decs-p2",
    d: "M375.81,745.43c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am-4",
    "data-name": "am",
    className: "cls-3-slide-decs-p2",
    d: "M211.25,786.09c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "cls-3-slide-decs-p2",
    d: "M223.75,784.39c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM223.68,796.21c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-4",
    "data-name": "ap",
    className: "cls-3-slide-decs-p2",
    d: "M238.48,784.39c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-8",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M248.12,794.37c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-17",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M257.7,784.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM261.23,789.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-5",
    "data-name": "ap",
    className: "cls-3-slide-decs-p2",
    d: "M272.43,784.39c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-9",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M282.07,794.37c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "cls-3-slide-decs-p2",
    d: "M291.85,780.52c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM290.09,797.56v-2.38h2.31v2.38h-2.31"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M251.53,916.33h-1v-16.58h1v16.58ZM252.2,870.43h-1v-13.7h1v13.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M251.69,856.24l.5-.03v.55h-1v-.54l.5.02Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M251.69,856.22l.54-.03v.58h-1.05v-.6l.51.05ZM251.23,856.72h.95v-.48l-.5.03-.46-.03v.48Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M251.03,931.1l-4.64-14.27h9.27l-4.63,14.27Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M251.03,932.7l-5.32-16.38h10.64l-5.32,16.38ZM247.08,917.32l3.94,12.15,3.94-12.14h-7.88Z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "i-2",
    "data-name": "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "cls-6-slide-decs-p2",
    d: "M246.31,889.97l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "cls-6-slide-decs-p2",
    d: "M260.51,872.93c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM260.51,888.34c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "slide-decks-disable-rect",
    d: "M81.02,939.2c0-3.31,2.69-6,6-6h328.02c3.31,0,6,2.69,6,6v134.8c0,3.31-2.69,6-6,6H87.02c-3.31,0-6-2.69-6-6v-134.8Z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "a-3",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M-4",
    "data-name": "M",
    className: "cls-4-slide-decs-p2",
    d: "M130.12,967.87c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM123.53,967.12c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM123.53,974.93c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-8",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M143.29,965.7c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-10",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M145.26,961.08v-2.04h2.17v2.04h-2.17ZM145.26,976.76v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-20",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M155.78,963.59c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM159.31,969.09c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q-3",
    "data-name": "Q",
    className: "cls-4-slide-decs-p2",
    d: "M169.43,960.88c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-11",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M170.99,961.08v-2.04h2.17v2.04h-2.17ZM170.99,976.76v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-5",
    "data-name": "R",
    className: "cls-4-slide-decs-p2",
    d: "M182.67,963.59c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-4",
    "data-name": "S",
    className: "cls-4-slide-decs-p2",
    d: "M200.33,963.86c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM194.69,975.27c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-4",
    "data-name": "T",
    className: "cls-4-slide-decs-p2",
    d: "M212.68,973.57c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "cls-4-slide-decs-p2",
    d: "M222.26,963.59c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM222.19,975.41c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "n-2",
    "data-name": "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X-6",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M245.41,974.32c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM239.1,973.17c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-5",
    "data-name": "S",
    className: "cls-4-slide-decs-p2",
    d: "M261.44,963.86c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM255.8,975.27c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-21",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M269.79,963.59c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM273.32,969.09c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-6",
    "data-name": "R",
    className: "cls-4-slide-decs-p2",
    d: "M284.52,963.59c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-5",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M296.68,965.29c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "cls-4-slide-decs-p2",
    d: "M314.54,963.86l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "o-2",
    "data-name": "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-3",
    "data-name": "aC",
    className: "cls-4-slide-decs-p2",
    d: "M328.18,963.59c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM328.12,975.41c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-9",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M342.72,965.7c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "p-2",
    "data-name": "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-5",
    "data-name": "T",
    className: "cls-4-slide-decs-p2",
    d: "M353.85,973.57c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-3",
    "data-name": "U",
    className: "cls-4-slide-decs-p2",
    d: "M363.83,965.29c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-22",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M377.01,963.59c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM380.54,969.09c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "q-2",
    "data-name": "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "cls-4-slide-decs-p2",
    d: "M138.64,1004.66c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM138.09,1016.47c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-10",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M152.15,1006.76c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-7",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M162.06,1015.39c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM155.75,1014.23c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-7",
    "data-name": "R",
    className: "cls-4-slide-decs-p2",
    d: "M174.01,1004.66c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-11",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M185.42,1004.66c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM186.03,1006.29c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-2",
    "data-name": "aE",
    className: "cls-4-slide-decs-p2",
    d: "M193.23,1018.1l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-3",
    "data-name": "aF",
    className: "cls-4-slide-decs-p2",
    d: "M214.28,1006.36c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-23",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M227.11,1004.66c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM230.64,1010.16c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-12",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M239.68,1004.66c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM240.29,1006.29c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-12",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M249.11,1002.15v-2.04h2.17v2.04h-2.17ZM249.11,1017.83v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-6",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M259.37,1006.36c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-8",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M274.64,1015.39c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM268.33,1014.23c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-6",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M280.28,1017.83v-17.72h2.17v17.72h-2.17"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-6",
    "data-name": "T",
    className: "cls-4-slide-decs-p2",
    d: "M294.81,1014.64c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-24",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M304.38,1004.66c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM307.92,1010.16c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-9",
    "data-name": "X",
    className: "cls-4-slide-decs-p2",
    d: "M320.75,1015.39c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM314.43,1014.23c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-4",
    "data-name": "aF",
    className: "cls-4-slide-decs-p2",
    d: "M339.01,1006.36c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-7",
    "data-name": "T",
    className: "cls-4-slide-decs-p2",
    d: "M355.85,1014.64c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-4",
    "data-name": "aC",
    className: "cls-4-slide-decs-p2",
    d: "M365.43,1004.66c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM365.36,1016.47c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-7",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M147.5,1047.42c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-5",
    "data-name": "aC",
    className: "cls-4-slide-decs-p2",
    d: "M159.99,1045.72c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM159.93,1057.54c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-5",
    "data-name": "aF",
    className: "cls-4-slide-decs-p2",
    d: "M181.04,1047.42c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-2",
    "data-name": "W",
    className: "cls-4-slide-decs-p2",
    d: "M194.89,1045.72c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM194.35,1057.54c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-7",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M202.3,1058.9v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-25",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M212.82,1045.72c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM216.35,1051.22c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-8",
    "data-name": "T",
    className: "cls-4-slide-decs-p2",
    d: "M223.62,1055.71c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-26",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M233.19,1045.72c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM236.72,1051.22c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "V-2",
    "data-name": "V",
    className: "cls-4-slide-decs-p2",
    d: "M255.94,1049.19c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-8",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M260.62,1058.9v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-13",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M265.99,1043.21v-2.04h2.17v2.04h-2.17ZM265.99,1058.9v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-13",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M275.49,1045.72c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM276.1,1047.35c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-27",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M290.09,1045.72c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM293.62,1051.22c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-14",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M309.44,1045.72c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM310.05,1047.35c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-28",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M324.04,1045.72c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM327.57,1051.22c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-8",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M337.35,1047.42c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-4",
    "data-name": "Y",
    className: "cls-4-slide-decs-p2",
    d: "M352.76,1058.9l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-4-slide-decs-p2",
    d: "M357.52,1058.9v-2.58h2.31v2.58h-2.31"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15-slide-decs-p2",
    d: "M251.03,1081v36.45"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M251.53,1081h-1v-.5h1v.5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-slide-decs-p2",
    d: "M251.03,1132.2l-4.64-14.25h9.27l-4.63,14.25Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M250.41,1519.2h-1v-13.67h1v13.67ZM249.39,1476.2h-1v-22.2h1v22.2Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M249.39,1454.03h-1v-3.52h1v3.52Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M249.91,1533.97l-4.63-14.26h9.26l-4.63,14.26Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M249.91,1535.6l-5.32-16.4h10.65l-5.33,16.4ZM245.97,1520.2l3.95,12.15,3.95-12.14h-7.9Z"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "d-3",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z-3",
    "data-name": "Z",
    className: "cls-7-slide-decs-p2",
    d: "M233.75,1488.76v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-3",
    "data-name": "aa",
    className: "cls-7-slide-decs-p2",
    d: "M242.78,1495.76v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "cls-7-slide-decs-p2",
    d: "M269.6,1482.92c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-slide-decs-p2",
    d: "M243.34,1315.4c3.55-1.48,7.53-1.48,11.08,0l160.05,66.6c1.27.54,1.86,2.01,1.32,3.28-.25.59-.73,1.07-1.32,1.32l-160.05,66.6c-3.55,1.48-7.53,1.48-11.08,0l-160.05-66.6c-1.27-.54-1.86-2.01-1.32-3.28.25-.59.73-1.07,1.32-1.32l160.05-66.6Z"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "f-3",
    "data-name": "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-3",
    "data-name": "ac",
    className: "cls-3-slide-decs-p2",
    d: "M198.1,1355.69c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "cls-3-slide-decs-p2",
    d: "M203.46,1368.52v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-6",
    "data-name": "ae",
    className: "cls-3-slide-decs-p2",
    d: "M208.83,1352.84v-2.04h2.17v2.04h-2.17ZM208.83,1368.52v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-4",
    "data-name": "af",
    className: "cls-3-slide-decs-p2",
    d: "M218.33,1355.35c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM218.95,1356.98c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-18",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M232.93,1355.35c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM236.46,1360.85c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-7",
    "data-name": "ah",
    className: "cls-3-slide-decs-p2",
    d: "M248.89,1358.81c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-3",
    "data-name": "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai-3",
    "data-name": "ai",
    className: "cls-3-slide-decs-p2",
    d: "M272.99,1357.05c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-19",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M285.83,1355.35c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM289.36,1360.85c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-20",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M299.41,1355.35c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM302.94,1360.85c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-10",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M310.2,1365.33c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h-3",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-21",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M180.72,1396.42c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM184.25,1401.92c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-3",
    "data-name": "ak",
    className: "cls-3-slide-decs-p2",
    d: "M197.08,1409.59l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-4",
    "data-name": "al",
    className: "cls-3-slide-decs-p2",
    d: "M207.54,1396.42c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM206.99,1408.23c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-22",
    "data-name": "ag",
    className: "cls-3-slide-decs-p2",
    d: "M220.1,1396.42c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM223.63,1401.92c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-5",
    "data-name": "am",
    className: "cls-3-slide-decs-p2",
    d: "M233.41,1398.11c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-11",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M243.12,1406.4c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-6",
    "data-name": "an",
    className: "cls-3-slide-decs-p2",
    d: "M255.48,1407.15c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM249.16,1405.99c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-12",
    "data-name": "aj",
    className: "cls-3-slide-decs-p2",
    d: "M263.49,1406.4c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-7",
    "data-name": "ae",
    className: "cls-3-slide-decs-p2",
    d: "M267.9,1393.9v-2.04h2.17v2.04h-2.17ZM267.9,1409.59v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "cls-3-slide-decs-p2",
    d: "M278.43,1396.42c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM278.36,1408.23c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-6",
    "data-name": "ap",
    className: "cls-3-slide-decs-p2",
    d: "M293.16,1396.42c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-8",
    "data-name": "ah",
    className: "cls-3-slide-decs-p2",
    d: "M307.96,1399.88c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "cls-3-slide-decs-p2",
    d: "M318.01,1392.55c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM316.25,1409.59v-2.38h2.31v2.38h-2.31"
  })))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M64.14,1007.1H6.59l-.88.07-.83.2-.8.34-.75.46-.65.56-.56.65-.45.74-.34.8-.2.84-.07.88v365.65l.06.88.2.84.33.8.44.72.56.66.65.56.74.45.8.32.83.2.88.07h21.22v1H6.53l-1-.1-1-.22-.94-.4-.87-.53-.77-.66-.67-.8-.54-.86-.4-.94-.24-1-.07-1v-365.68l.06-1,.24-1,.4-.93.53-.87.66-.77.76-.66.87-.53.95-.38,1-.24,1-.08h57.56l.09.96ZM80.74,1383.8v1h-16.34v-1h16.34Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M81.25,1384.3l.06.5h-.57v-1h.57l-.06.5Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M81.29,1384.3l.05.52h-.63v-1.05h.63l-.05.53ZM80.76,1383.82v.95h.52l-.06-.48.05-.48h-.51Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M78.89,1006.6l-14.25,4.64v-9.27l14.25,4.63Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M80.52,1006.6l-16.38,5.33v-10.65l16.38,5.32ZM65.14,1010.55l12.15-3.95-12.15-3.94v7.89Z"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "i-3",
    "data-name": "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "cls-6-slide-decs-p2",
    d: "M40.72,1389.18l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "cls-6-slide-decs-p2",
    d: "M54.91,1372.14c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM54.91,1387.55c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "slide-decks-disable-rect",
    d: "M77.75,1140.33c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H83.75c-3.31,0-6-2.69-6-6h0v-86.67Z"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "j-3",
    "data-name": "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "cls-4-slide-decs-p2",
    d: "M161.45,1177.19c-.31-2.96-7.59-3.33-7.65.12.86,4.63,9.75.86,10.06,7.35.19,4.81-7.47,5.37-10.8,3.4-1.05-.62-1.73-1.6-2.04-2.84l2.04-.43c.31,3.46,8.7,3.89,8.7-.06,0-4.81-9.57-.86-10-7.28-.31-5.06,8.95-5.19,11.05-2.1.31.43.49.99.68,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-9",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M166.33,1188.86v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-14",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M171.2,1174.6v-1.85h1.98v1.85h-1.98ZM171.2,1188.86v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-15",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M179.84,1176.88c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM180.4,1178.36c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-29",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M193.12,1176.88c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM196.33,1181.88c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k-3",
    "data-name": "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-16",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M210.71,1176.88c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM211.26,1178.36c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-30",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M223.98,1176.88c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM227.19,1181.88c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-9",
    "data-name": "aw",
    className: "cls-4-slide-decs-p2",
    d: "M236.08,1178.43c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-5",
    "data-name": "Y",
    className: "cls-4-slide-decs-p2",
    d: "M250.09,1188.86l-3.95-5.37-1.42,1.17v4.2h-1.98v-16.11h1.98v10.06l5.12-5.68h2.28l-4.75,5.06,5.06,6.67h-2.35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l-3",
    "data-name": "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-17",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M263.8,1176.88c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM264.35,1178.36c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-31",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M277.07,1176.88c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM280.28,1181.88c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-10",
    "data-name": "au",
    className: "cls-4-slide-decs-p2",
    d: "M284.72,1188.86v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-15",
    "data-name": "O",
    className: "cls-4-slide-decs-p2",
    d: "M289.6,1174.6v-1.85h1.98v1.85h-1.98ZM289.6,1188.86v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "cls-4-slide-decs-p2",
    d: "M299.66,1188.86h-2.35l-4.26-11.73h2.1l3.33,10.19,3.46-10.19h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-32",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M310.28,1176.88c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM313.49,1181.88c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-11",
    "data-name": "N",
    className: "cls-4-slide-decs-p2",
    d: "M323.49,1178.8c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-33",
    "data-name": "P",
    className: "cls-4-slide-decs-p2",
    d: "M329.97,1176.88c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM333.18,1181.88c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-18",
    "data-name": "av",
    className: "cls-4-slide-decs-p2",
    d: "M341.39,1176.88c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM341.94,1178.36c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p2",
    d: "M78.79,1541.6c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v92c0,3.31-2.69,6-6,6H84.79c-3.31,0-6-2.69-6-6h0v-92Z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "t-2",
    "data-name": "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG-3",
    "data-name": "aG",
    className: "cls-4-slide-decs-p2",
    d: "M190.5,1580.79c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-4",
    "data-name": "aH",
    className: "cls-4-slide-decs-p2",
    d: "M207.89,1589.89c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM204.83,1585.2c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-5",
    "data-name": "aH",
    className: "cls-4-slide-decs-p2",
    d: "M221.47,1589.89c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM218.41,1585.2c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "u-2",
    "data-name": "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI-3",
    "data-name": "aI",
    className: "cls-4-slide-decs-p2",
    d: "M230.9,1576.31c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM234.44,1584.52c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-2",
    "data-name": "aJ",
    className: "cls-4-slide-decs-p2",
    d: "M253.31,1582.48c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK-2",
    "data-name": "aK",
    className: "cls-4-slide-decs-p2",
    d: "M269.47,1590.84c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM266.21,1591.04c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-2",
    "data-name": "aL",
    className: "cls-4-slide-decs-p2",
    d: "M283.32,1583.77c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-6",
    "data-name": "aH",
    className: "cls-4-slide-decs-p2",
    d: "M300.16,1589.89c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM297.11,1585.2c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "v-2",
    "data-name": "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aM-2",
    "data-name": "aM",
    className: "cls-4-slide-decs-p2",
    d: "M316.66,1584.52c2.31.27,3.8,1.43,4.01,3.94.48,6.18-10.05,6.38-11.68,1.9-.27-.61-.41-1.15-.48-1.77l3.46-.34c.07,1.63,1.09,2.38,2.72,2.44,1.56,0,2.65-.81,2.58-2.44-.07-2.1-2.1-2.44-4.41-2.31v-2.72c2.17.14,4.01-.2,4.01-2.24,0-1.36-.88-2.24-2.31-2.24s-2.24.88-2.38,2.17l-3.4-.2c.41-2.99,2.51-4.62,5.84-4.62s5.64,1.36,5.64,4.48c0,2.38-1.49,3.53-3.6,3.94"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15-slide-decs-p2",
    d: "M248.89,1234v63.41"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M249.39,1234h-1v-.5h1v.5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-slide-decs-p2",
    d: "M248.89,1312.17l-4.65-14.26h9.28l-4.63,14.26Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M505.59,479.53l1,.23.94.4.87.53.78.65.67.78.53.87.4.94.23,1,.1,1v514.67l-.1,1-.23,1-.4.94-.52.87-.67.77-.77.66-.86.54-.94.4-1,.23-1,.07h-66.67v-1h66.64l.88-.06.83-.2.8-.34.74-.45.65-.56.56-.66.45-.74.33-.8.22-.84.07-.88V485.95l-.08-.9-.2-.83-.34-.8-.45-.73-.56-.66-.65-.56-.74-.45-.8-.33-.83-.2-.88-.07h-21.64v-1h21.64l1,.11ZM420.09,480.45v-1h13.94v1h-13.94Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M420.11,480.45h-.57l.06-.5-.05-.5h.57v1Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M420.14,480.47h-.63l.06-.52-.06-.53h.63v1.05ZM419.57,479.47l.05.48-.05.47h.52v-.95h-.52Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-slide-decs-p2",
    d: "M437.42,1011.24l-14.26-4.64,14.26-4.63v9.27Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-slide-decs-p2",
    d: "M437.92,1011.93l-16.38-5.33,16.38-5.32v10.65ZM424.77,1006.6l12.15,3.95v-7.9l-12.15,3.95Z"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "d-4",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z-4",
    "data-name": "Z",
    className: "cls-7-slide-decs-p2",
    d: "M443.35,477.84v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-4",
    "data-name": "aa",
    className: "cls-7-slide-decs-p2",
    d: "M452.38,484.84v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-4",
    "data-name": "ab",
    className: "cls-7-slide-decs-p2",
    d: "M479.2,472c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideDecsPhase2);
export default __webpack_public_path__ + "static/media/Slide_Decs_Phase_2.f6eea6fd978a2c5d3766e704de48b1c4.svg";
export { ForwardRef as ReactComponent };